import React from "../../_snowpack/pkg/react.js";
import {CardDeck} from "../pages/index.js";
const App = () => {
  return /* @__PURE__ */ React.createElement(CardDeck, null);
};
export default App;
